(function () {
  if (window.__videoGalleryReady) return;
  window.__videoGalleryReady = true;

  function init(root) {
    if (!root || root.dataset.videoGalleryInitialized === 'true') return;

    var viewport = root.querySelector('[data-vg-viewport]');
    var track = root.querySelector('[data-vg-track]');
    var btnPrev = root.querySelector('[data-vg-prev]');
    var btnNext = root.querySelector('[data-vg-next]');
    if (!viewport || !track || !btnPrev || !btnNext) return;

    root.dataset.videoGalleryInitialized = 'true';

    var qsa = function (selector, context) {
      return Array.from((context || document).querySelectorAll(selector));
    };

    function getVisibleCount() {
      var value = getComputedStyle(root).getPropertyValue('--visible').trim();
      var count = parseInt(value, 10);
      return Number.isFinite(count) && count > 0 ? count : 4;
    }

    function stopAllVideos() {
      qsa('.vg__card.is-playing', root).forEach(function (card) {
        var video = card.querySelector('video');
        if (video) {
          try { video.pause(); } catch (e) {}
          try { video.currentTime = 0; } catch (e) {}
        }
        card.classList.remove('is-playing', 'has-played');
      });
    }

    function initPostersAndControls() {
      qsa('[data-vg-slide]', track).forEach(function (slide) {
        var card = slide.querySelector('.vg__card');
        var media = slide.querySelector('.vg__media');
        var video = slide.querySelector('video.vg__video');
        var playBtn = slide.querySelector('[data-vg-play]');
        if (!card || !media || !video || !playBtn) return;
        if (card.dataset.vgInit === '1') return;
        card.dataset.vgInit = '1';

        try { video.controls = false; } catch (e) {}

        function setState(playing) {
          card.classList.toggle('is-playing', !!playing);
          var S = (window.gwaStrings && window.gwaStrings.video_gallery) || {};
          playBtn.setAttribute('aria-label', playing ? (root.dataset.pauseLabel || 'Pause video') : (S.play_video || 'Play video'));
          playBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
        }

        function stop() {
          try { video.pause(); } catch (e) {}
          try { video.currentTime = 0; } catch (e) {}
          setState(false);
          card.classList.remove('has-played');
        }

        function pause() {
          try { video.pause(); } catch (e) {}
          setState(false);
        }

        function play() {
          stopAllVideos();
          try {
            if (!video.dataset.sourcesLoaded) {
              if (video.dataset.src) video.src = video.dataset.src;
              video.querySelectorAll('source[data-src]').forEach(function(source) { source.src = source.dataset.src; });
              video.dataset.sourcesLoaded = 'true';
              video.load();
            }
            setState(true);
            var promise = video.play();
            if (promise && typeof promise.then === 'function') {
              promise.then(function () {
                setState(!video.paused);
              }).catch(function () {
                setState(false);
              });
            } else {
              setState(true);
            }
          } catch (e) {
            setState(false);
          }
        }

        var lastToggleAt = 0;
        var pointerStartX = 0;
        var pointerStartY = 0;

        function shouldIgnoreToggle(event) {
          var target = event.target;
          return target && target.closest && target.closest('.vg__instagram');
        }

        function toggleFromMedia(event) {
          event.preventDefault();
          event.stopPropagation();
          lastToggleAt = Date.now();
          if (card.classList.contains('is-playing')) pause();
          else play();
        }

        media.addEventListener('pointerdown', function (event) {
          pointerStartX = event.clientX || 0;
          pointerStartY = event.clientY || 0;
        });

        media.addEventListener('pointerup', function (event) {
          if (shouldIgnoreToggle(event)) return;
          if (Date.now() - lastToggleAt < 350) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          if (event.pointerType === 'mouse') return;
          var dx = (event.clientX || 0) - pointerStartX;
          var dy = (event.clientY || 0) - pointerStartY;
          if (Math.sqrt((dx * dx) + (dy * dy)) > 12) return;
          toggleFromMedia(event);
        });

        media.addEventListener('click', function (event) {
          if (shouldIgnoreToggle(event)) return;
          if (Date.now() - lastToggleAt < 350) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          toggleFromMedia(event);
        });

        video.addEventListener('ended', stop);
        video.addEventListener('playing', function () {
          card.classList.add('has-played');
          setState(true);
        });
        video.addEventListener('pause', function () {
          setState(false);
        });
      });
    }

    var K = 2;
    var index = 0;
    var slideW = 0;
    var gap = 0;
    var isAnimating = false;
    var normalizeTimer = null;

    function setTransition(on) {
      track.style.transition = on ? 'transform 420ms ease' : 'none';
    }

    function measure() {
      var slides = qsa('[data-vg-slide]', track);
      var first = slides[0];
      if (!first) return;
      slideW = first.getBoundingClientRect().width;
      var styles = getComputedStyle(track);
      gap = parseFloat(styles.gap || styles.columnGap || '0') || 0;
    }

    function setX(i) {
      track.style.transform = 'translate3d(' + (-i * (slideW + gap)) + 'px,0,0)';
    }

    function getRealSlides() {
      return qsa('[data-vg-slide]', track).filter(function (slide) {
        return !slide.hasAttribute('data-vg-clone');
      });
    }

    function removeClones() {
      qsa('[data-vg-clone="1"]', track).forEach(function (node) {
        node.remove();
      });
    }

    function makeClone(slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('data-vg-clone', '1');
      clone.querySelectorAll('video, source').forEach(function(media) {
        media.removeAttribute('src');
        delete media.dataset.sourcesLoaded;
      });
      clone.querySelectorAll('.vg__card').forEach(function(card) {
        card.dataset.vgInit = '0';
        card.classList.remove('is-playing', 'has-played');
      });
      return clone;
    }

    function buildBufferedClones() {
      removeClones();
      var reals = getRealSlides();
      var realCount = reals.length;
      if (realCount < 2) { K = 0; index = 0; return; }

      K = Math.min(realCount, Math.max(2, getVisibleCount() + 1));

      reals.slice(-K).reverse().forEach(function(slide) {
        track.insertBefore(makeClone(slide), track.firstChild);
      });
      reals.slice(0, K).forEach(function(slide) {
        track.appendChild(makeClone(slide));
      });

      measure();
      index = K;
      setTransition(false);
      setX(index);
      initPostersAndControls();
    }

    function scheduleNormalize() {
      if (normalizeTimer) clearTimeout(normalizeTimer);
      normalizeTimer = setTimeout(function () {
        normalize(true);
      }, 520);
    }

    function normalize(force) {
      var realCount = getRealSlides().length;
      if (realCount < 2) {
        isAnimating = false;
        return;
      }

      if (index < K) {
        index += realCount;
        setTransition(false);
        setX(index);
      } else if (index >= K + realCount) {
        index -= realCount;
        setTransition(false);
        setX(index);
      } else if (force) {
        setTransition(false);
        setX(index);
      }

      isAnimating = false;
    }

    function go(dir) {
      var realCount = getRealSlides().length;
      if (isAnimating || realCount < 2) return;

      isAnimating = true;
      stopAllVideos();
      index += dir;
      setTransition(true);
      setX(index);
      scheduleNormalize();
    }

    function onEndOrCancel() {
      if (!isAnimating) return;
      normalize(false);
    }

    track.addEventListener('transitionend', onEndOrCancel);
    track.addEventListener('transitioncancel', onEndOrCancel);

    btnPrev.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      go(-1);
    });
    btnNext.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      go(1);
    });

    var startX = 0;
    var curX = 0;
    var dragging = false;

    function shouldIgnoreDown(event) {
      var target = event.target;
      return target && target.closest && target.closest('[data-vg-prev],[data-vg-next],.vg__media');
    }

    function onDown(event) {
      if (shouldIgnoreDown(event)) return;
      if (getRealSlides().length < 2) return;

      dragging = true;
      isAnimating = true;
      stopAllVideos();
      setTransition(false);
      if (normalizeTimer) clearTimeout(normalizeTimer);

      startX = event.touches ? event.touches[0].clientX : event.clientX;
      curX = startX;
    }

    function onMove(event) {
      if (!dragging) return;
      curX = event.touches ? event.touches[0].clientX : event.clientX;
      var dx = curX - startX;
      var x = -index * (slideW + gap) + dx;
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    }

    function onUp() {
      if (!dragging) return;
      dragging = false;

      var dx = curX - startX;
      var threshold = Math.min(80, slideW * 0.18);
      if (dx > threshold) index -= 1;
      else if (dx < -threshold) index += 1;

      setTransition(true);
      setX(index);
      scheduleNormalize();
    }

    viewport.addEventListener('mousedown', onDown);
    viewport.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);

    viewport.addEventListener('touchstart', onDown, { passive: true });
    viewport.addEventListener('touchmove', onMove, { passive: true });
    viewport.addEventListener('touchend', onUp, { passive: true });

    var lastVisible = getVisibleCount();
    function onResize() {
      var nowVisible = getVisibleCount();
      if (nowVisible !== lastVisible) {
        lastVisible = nowVisible;
        stopAllVideos();
        setTransition(false);
        buildBufferedClones();
        normalize(true);
      } else {
        var prevW = slideW;
        measure();
        if (Math.abs(slideW - prevW) > 0.5) {
          setTransition(false);
          setX(index);
        }
      }
    }
    var ro;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(onResize);
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', onResize, { passive: true });
    }
    root.__vgDestroy = function() {
      if (ro) ro.disconnect();
      window.removeEventListener('resize', onResize);
      window.removeEventListener('mouseup', onUp);
      clearTimeout(normalizeTimer);
      stopAllVideos();
    };

    initPostersAndControls();
    measure();
    buildBufferedClones();
    normalize(true);
  }

  function schedule(root) {
    if (root.__vgScheduled) return;
    root.__vgScheduled = true;
    var observer;
    function activate() {
      if (observer) observer.disconnect();
      root.removeEventListener('pointerdown', activate, true);
      root.removeEventListener('focusin', activate);
      init(root);
    }
    root.__vgCancel = function() {
      if (observer) observer.disconnect();
      root.removeEventListener('pointerdown', activate, true);
      root.removeEventListener('focusin', activate);
      if (root.__vgDestroy) root.__vgDestroy();
    };
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      activate();
      return;
    }
    observer = new IntersectionObserver(function(entries) {
      if (entries.some(function(entry) { return entry.isIntersecting; })) activate();
    }, { rootMargin: '400px 0px' });
    observer.observe(root);
    root.addEventListener('pointerdown', activate, true);
    root.addEventListener('focusin', activate);
  }

  function forEachRoot(scope, callback) {
    var context = scope || document;
    if (context.matches && context.matches('[data-vg]')) callback(context);
    context.querySelectorAll('[data-vg]').forEach(callback);
  }

  forEachRoot(document, schedule);
  document.addEventListener('shopify:section:load', function(event) {
    forEachRoot(event.target, schedule);
  });
  document.addEventListener('shopify:section:unload', function(event) {
    forEachRoot(event.target, function(root) { if (root.__vgCancel) root.__vgCancel(); });
  });
})();
